(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockBausteinAuswahl', {
            require: {
                form: '^form'
            },
            bindings: {
                bausteinBeitrag: '<abbaBausteinBeitrag',
                changeBaustein: '&?abbaChangeBaustein',
                kombinierteBeitraege: '<?abbaKombinierteBeitraege',
                tarifdetailsName: '@abbaTarifdetailsName',
                toggleTarifdetails: '&?abbaToggleTarifdetails',
                onTarifdetailsFiltered: '&?abbaOnTarifdetailsFiltered',
                isOpen: '=?abbaIsOpen',
                disabled: '<?abbaDisabled',
                options: '<abbaOptions'
            },
            transclude: {
                content: '?content',
                bausteinZusatz: '?bausteinZusatz'
            },
            templateUrl: 'bloecke/ergebnis/blockBausteinAuswahl.html',
            controller: BlockBausteinAuswahlController,
            controllerAs: 'blockBausteinAuswahlVm'
        });

    BlockBausteinAuswahlController.$inject = [
        '$scope',
        '$transclude',
        '$modal',
        '$element',
        '$analytics',
        'lodash',
        'AppConfig',
        'MoneyUtilsService',
        'MiscUtilsService',
        'TrackingUtilsService'
    ];
    function BlockBausteinAuswahlController($scope, $transclude, $modal, $element, $analytics, _, AppConfig, MoneyUtilsService, MiscUtilsService, TrackingUtilsService) {
        var vm = this,
            zahlweiseTextMap;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.toggleTarifdetailsContent = toggleTarifdetailsContent;
        vm.getButtonLabel = getButtonLabel;
        vm.onBausteinAktivChanged = onBausteinAktivChanged;
        vm.onOpenBaustein = onOpenBaustein;
        vm.onCloseBaustein = onCloseBaustein;
        vm.openTarifdetails = openTarifdetails;
        vm.isBlockBausteinZusatzSichtbar = isBlockBausteinZusatzSichtbar;

        function activate() {
            vm.options = vm.options || {};
            zahlweiseTextMap = AppConfig.ANGEBOT.zahlweiseText;

            vm.gridLayoutCss = vm.options.grid || {};
            vm.showLabelZusatz = vm.options.showLabelZusatz;
            vm.showTarifdetails = vm.options.showTarifdetails;
            vm.tarifdetailsTextProp = vm.options.tarifdetailsTextProp;
            vm.tarifdetailsFilter = vm.options.tarifdetailsFilter;
            vm.tarifartProperty = 'tarifartModellierung';
            vm.kombinierteBeitraege = _.compact(vm.kombinierteBeitraege);

            vm.hasTarifdetails = !!vm.tarifdetailsName;
            vm.hasBausteinZusatzTransclude = $transclude.isSlotFilled('bausteinZusatz');
            vm.hasContentTransclude = $transclude.isSlotFilled('content');

            vm.hasContent = (
                vm.hasContentTransclude ||
                vm.hasBausteinZusatzTransclude ||
                vm.hasTarifdetails
            );

            vm.labelZusatzAnzeigen = _.isNil(vm.showLabelZusatz) ? true : vm.showLabelZusatz;
            vm.isBausteinAenderbar = _.isNil(vm.options.isBausteinAenderbar) ? true : vm.options.isBausteinAenderbar;
            vm.bausteinTarifart = _.get(vm.bausteinBeitrag, 'baustein.' + vm.tarifartProperty);
            vm.zahlweiseText = zahlweiseTextMap[_.get(vm.bausteinBeitrag, 'beitrag.' + _.get(vm.bausteinTarifart, 'wert') + '.zahlweise.wert')];

            vm.beitrag = getBeitrag();
            vm.label = getLabel();

            vm.trackingName = ($element[0].getAttribute('data-wgvt-name') || _.get(vm.bausteinBeitrag, 'bausteinKey') + 'Auswahl');
        }

        function onChanges() {
            activate();
        }

        function onInit() {
            vm.fieldName = [
                _.get(vm.bausteinBeitrag, 'bausteinKey') + 'Auswahl',
                MiscUtilsService.guid('#')
            ].join('_');

            activate();

            if (_.get(vm.bausteinBeitrag, 'baustein.aktiv') && _.get(vm.options, 'hideSelectBtn') !== true) {
                TrackingUtilsService.trackDefaultEvent('button', 'wgv', [{
                    name: vm.trackingName,
                    value: true,
                    state: vm.disabled ? 'unchangeable' : 'default'
                }]);
            }
        }

        function toggleTarifdetailsContent(open) {
            if (_.isFunction(vm.toggleTarifdetails)) {
                vm.toggleTarifdetails({
                    open: open
                });
            }
        }
        function getLabel() {
            return {
                deckung: _.get(vm.bausteinLabel, 'deckung') || _.get(vm.bausteinBeitrag, 'infos.label.deckung'),
                zusatz: _.get(vm.bausteinLabel, 'zusatz') || _.get(vm.bausteinBeitrag, 'infos.label.zusatz')
            };
        }
        function getBeitrag() {
            var beitrag;

            if (vm.kombinierteBeitraege && vm.kombinierteBeitraege.length) {
                return MoneyUtilsService.summation.apply(null, _.map(vm.kombinierteBeitraege, function (beitrag) {
                    return _.get(beitrag[_.get(vm.bausteinBeitrag, 'baustein.' + vm.tarifartProperty + '.wert')], 'brutto');
                }));
            }

            if (vm.bausteinBeitrag && vm.bausteinBeitrag.baustein) {
                beitrag = _.get(vm.bausteinBeitrag, 'beitrag[' + _.get(vm.bausteinBeitrag, 'baustein.' + vm.tarifartProperty + '.wert') + ']');
            }
            return _.get(beitrag, 'brutto');
        }

        function getButtonLabel() {
            return _.get(vm.bausteinBeitrag, 'baustein.aktiv') ? 'Ausgewählt' : 'Auswählen';
        }

        function onBausteinAktivChanged($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.disabled) {
                $scope.$emit('iplusjs:showModalAngebotNichtAenderbar');
                return;
            }

            if (_.get(vm.bausteinBeitrag.baustein, 'aktiv') === false) {
                vm.isOpen = true;
            }

            if (angular.isFunction(vm.changeBaustein)) {
                vm.changeBaustein({
                    bausteinKey: vm.bausteinBeitrag.bausteinKey,
                    bausteinAktiv: !vm.bausteinBeitrag.baustein.aktiv,
                    baustein: vm.bausteinBeitrag.baustein,
                    gegenstand: vm.bausteinBeitrag.gegenstand,
                    gegenstandKey: vm.bausteinBeitrag.gegenstand
                });
            }
        }

        function onOpenBaustein() {
            if (!vm.hasContent) {
                return;
            }

            if (vm.isOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: vm.trackingName,
                    value: 'open'
                });
            }
        }

        function onCloseBaustein() {
            if (!vm.hasContent) {
                return;
            }

            if (vm.isOpen !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: vm.trackingName,
                    value: 'close'
                });
            }
        }

        function openTarifdetails() {
            var modalTarifdetails = $modal.open({
                templateUrl: 'modal/modalTarifdetails.html',
                windowClass: 'xlarge',
                controller: 'ModalTarifdetailsController',
                controllerAs: 'modalVm',
                resolve: { /* @ngInject */
                    tarifdetails: [function () {
                        return {
                            name: vm.tarifdetailsName,
                            title: vm.options.tarifdetailsTitle,
                            tarifart: vm.bausteinTarifart,
                            textProp: vm.tarifdetailsTextProp,
                            onTarifdetailsFiltered: vm.onTarifdetailsFiltered,
                            tarifdetailsFilter: vm.tarifdetailsFilter,
                            baustein: _.get(vm.bausteinBeitrag, 'baustein'),
                            options: {
                                grid: vm.gridLayoutCss.tarifdetails,
                                hideButtons: true,
                                trackingName: 'details_' + vm.trackingName
                            }
                        };
                    }]
                }
            });

            modalTarifdetails.result.then(function () {
                focusElementAfterCloseModal();
            }).catch(function (error) {
                focusElementAfterCloseModal();
            });
        }

        function isBlockBausteinZusatzSichtbar() {
            return (
                _.get(vm.bausteinBeitrag, 'baustein.aktiv') === true ||
                vm.options.showBausteinZusatz === true
            );
        }

        function focusElementAfterCloseModal() {
            if (!$element || !$element[0] || !$element[0].querySelector('a')) {
                return;
            }

            $element[0].querySelector('a').focus();
        }
    }

})();
